/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentPage } from 'state/slices/app';
import { fetchTrendingNowV2Config } from 'state/thunks/trendingnowv2';

// utils
import { useIsAdminUser } from 'utils/session';
// material
import { Page, Content, InContentMessage, InlineMessage, EmptyState } from '@insticator/insticator-ui';
import PageHeader from "material/structure/pageheader/pageheader";
import PageContent from "material/structure/pagecontent/pagecontent";
import SiteFilter from 'material/sitefilter/sitefilter';
import LoadingState from 'material/states/loading/loading';
// content
import GeneralSection from './generalsection/generalsection';
// styles
import injectSheet from "react-jss";
import styles from './trendingnowv2config_styles';
import AdvancedSection from './advancedsection/advancedsection';
import SiteThemeSection from './sitethemesection/sitethemesection';
import AdsSection from './adssection/adssection';


/* ========== ~~~~~~~~~~ TRENDING CONFIG V2 PAGE ~~~~~~~~~~ ========== */
const TrendingNowV2ConfigPage = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const { siteUUID, accountUUID } = useSelector(state => state.session);
  const { trendingNowConfig } = useSelector(state => state.trendingNowV2)

  const [isLoading,setIsLoading] = useState(true)
  const isAdmin = useIsAdminUser()

  useEffect(() => {
    if(accountUUID && siteUUID) loadTrendingNowV2Config()
  }, [accountUUID, siteUUID]) 

  const loadTrendingNowV2Config = useCallback(async()=>{
    setIsLoading(true)
    const response = await dispatch(fetchTrendingNowV2Config({ siteUUID }))
    setIsLoading(false)
  }, [siteUUID, accountUUID])
  

  const redirectToProductManager = () => dispatch(updateCurrentPage('/dashboard/productmanager'))

  if(trendingNowConfig.status === 'rejected') return (
    <Page name={'trendingnowv2configpage'} klass={`${props.classes.trendingnowv2configpage}`}>
      <SiteFilter disableTestPageButton={true} />
      <Content>
        <InContentMessage />
        <PageHeader title={'Trending Now'} subtitle={'Configuration'}  />
          <EmptyState 
            graphicName={'error-500'} 
            bodycopy={
              <div>
                <div>There's an error fetching the Trending Now 2.0 Configurations. </div>
                <div>Please try again later.</div>
              </div>
            } 
            buttonText={'Try again'}
            buttonClick={() => loadTrendingNowV2Config()}
          />
      </Content>
    </Page>
  )

  return (
    <Page name={'trendingnowv2configpage'} klass={`${props.classes.trendingnowv2configpage}`}>
      <SiteFilter disableTestPageButton={isLoading} />
      <Content>
        <InContentMessage />
        <PageHeader title={'Trending Now'} subtitle={'Configuration'}  />
        <PageContent>
        { isLoading ?
          <LoadingState />
          :
          <>
            { isAdmin &&
              <InlineMessage 
               key={'meow'}
               display={true}
               name={'productmanagermessage'}
               variant={'system'}
               icon={'exclamation-triangle'}
               message={
               <span>
                 See <span className={'productmanagerlink'} onClick={redirectToProductManager}>Product Manager</span> to 
                 enable/disable, get code, determine site placement, and more.
               </span>
               }
               close={false}
             />
            }
            <SiteThemeSection />
            <GeneralSection />
            <AdvancedSection />
            { isAdmin && 
              <AdsSection />
            }
          </>
        }
        </PageContent>
      </Content>
    </Page>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default TrendingNowV2ConfigPage